import { FontAwesome } from "@expo/vector-icons";
import React, { useEffect } from "react";
import {
  View,
  Platform,
} from "react-native";
import { useDispatch } from "react-redux";
import { StepHeader, GoInboxButton } from "../../../components/all";
import Styles from "../../../constants/styles";
import { resetFields } from "../../../reducers/auth/register";

export default function Step5({ navigation }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetFields())
  }, [])

  return (
    <View
      style={{
        ...Styles.webSmallContainer,
        marginTop: 250,
      }}
    >
      <StepHeader
        label={`Registration Complete`}
        icon={<FontAwesome name="thumbs-o-up" size={24} color="black" />}
        presubtitle={`Thank you for registering, we will verify your account\nand send you an email once it is approved.`}
        subtitle={""}
      />
      <View style={{ alignItems: "center", margin: 18, marginTop: 50 }}>
        {Platform.OS === "web" ? null : (
          <GoInboxButton
            onPress={() => {
              navigation.replace("AuthScreen");
            }}
          />
        )}
        {/* <TouchableOpacity
          onPress={() => {
            navigation.replace("AuthScreen");
          }}
        >
          <Text
            style={{
              margin: 10,
              fontSize: normalize(12),
              color: Colors.primary,
            }}
          >
            Back to Login
          </Text>
        </TouchableOpacity> */}
      </View>
    </View>
  );
}
